import { useTheme } from '@material-ui/core/styles'
import useMediaQuery from '@material-ui/core/useMediaQuery'

const useMobileBreakpoint = (options = null) => {
  const muiTheme = useTheme()
  return useMediaQuery(muiTheme.breakpoints.down('sm'), options)
}

export default useMobileBreakpoint
